import PropTypes from "prop-types";
import React from "react";
import styles from "./InfoHeader.module.css";
import DetailInfoButton from "../DetailInfoButton";
import ChevronLeft from "./Images/Chevrons.svg";
import More from "./Images/More.svg";
import { useTranslation } from "react-i18next";

/**
 * InfoHeader Component
 */
export function InfoHeader({
  pinLevel,
  firstName,
  lastName,
  iboNum,
  avatar,
  onMore,
  onDetails,
  onLOS,
  onBack,
}) {
  const { t } = useTranslation();
  React.useEffect(() => {
    const cls = "detail-visible";
    if (onDetails) {
      document.body.classList.add(cls);
    } else {
      document.body.classList.remove(cls);
    }
    return () => document.body.classList.remove(cls);
  }, [onDetails]);
  const pinLevelClass = `${styles.pinLevel} ${styles[pinLevel]}`;

  const pinLevelToTextMap = {
    1: "IBO",
    2: "Platinum",
    3: "Emerald",
    4: "Diamond",
  };

  return (
    <>
      <div className={styles.container}>
        {onBack && (
          <div className={styles.back} onClick={onBack}>
            <img src={ChevronLeft} />
          </div>
        )}
        {avatar.length > 1 && avatar[1] !== null ? (
          <div className={styles.avatarMultiple}>
            <img src={avatar[0]} className={styles.multiple} />
            <img src={avatar[1]} className={styles.multiple2} />
          </div>
        ) : (
          <div className={styles.avatar}>
            <img src={avatar[0]} />
          </div>
        )}

        <div className={styles.info}>
          <div className={styles.first}>{firstName}</div>
          <div className={styles.last}>{lastName}</div>
          <div className={pinLevelClass}>{t(pinLevelToTextMap[pinLevel])}</div>
        </div>
        <div className={styles.iboNum}>
          <div>
            <div>
              {`${t("IBO")}:`}
              <span className={styles.num}>{iboNum}</span>
            </div>
          </div>

          <div className={styles.btns}>
            {/* {onDetails && (
              <button className={styles.detailsBtn} onClick={onDetails}>
                {t("Details")}
              </button>
            )}
            {onLOS && (
              <button className={styles.detailsBtn} onClick={onLOS}>
                {t("LOS")}
              </button>
            )} */}

            {(onDetails || onLOS) && (
              <div className={styles.detailsBtn}>
                <DetailInfoButton
                  iboNumber={iboNum}
                  label={onDetails ? "Detail" : "LOS"}
                  display={onDetails ? t("Details") : t("LOS")}
                  onDetailClick={onDetails}
                  onLosClick={onLOS}
                />
              </div>
            )}
            {/* Hide for now */}
            {/* {onMore && (
              <div className={styles.moreBtn} onClick={onMore}>
                <img src={More} />
              </div>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
}

//  {onDetails && (
//             <div className={styles.detailsBtn}>
//               <DetailInfoButton
//                 iboNumber={iboNum}
//                 label="Detail"
//                 display={t('Details')}
//                 onDetailClick={onDetails}
//               />
//             </div>
//           )}
//           {onLOS && (
//             <div className={styles.detailsBtn}>
//               <DetailInfoButton
//                 iboNumber={iboNum}
//                 label="LOS"
//                 display={t('LOS')}
//                 onLosClick={onLOS}
//               />
//             </div>
//           )}
